<div class="page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()" fxFlex="5"><mat-icon svgIcon="left-arrow"></mat-icon></div>
    <div  class="header-text">Upload Application</div>
  </div>
  <div class="content" >
    @if (false) {
      <div  class="title-container">Upload your Application for Employment</div>
    }
    @if (false) {
      <div class="image-container">
        <img src="/assets/images/application-employment.png" class="img-note" />
      </div>
    }
    @if (true) {
      <div  class="document-list-container">
        <div fxFlex="22" class="document-list-item">
          <div class="document-row">
            <div  class="file-name">File name</div>
            <div  class="delete-icon-container"><mat-icon svgIcon="delete-icon"></mat-icon></div>
          </div>
          <mat-divider></mat-divider>
          <div class="document-row">
            <div  class="date-uploaded-text">Date Uploaded</div>
            <div  class="date-text">12th may 2021</div>
          </div>
        </div>
        <div fxFlex="22" class="document-list-item">
          <div class="document-row">
            <div  class="file-name">File name</div>
            <div  class="delete-icon-container"><mat-icon svgIcon="delete-icon"></mat-icon></div>
          </div>
          <mat-divider></mat-divider>
          <div class="document-row">
            <div  class="date-uploaded-text">Date Uploaded</div>
            <div  class="date-text">12th may 2021</div>
          </div>
        </div>
        <div fxFlex="22" class="document-list-item">
          <div class="document-row">
            <div  class="file-name">File name</div>
            <div  class="delete-icon-container"><mat-icon svgIcon="delete-icon"></mat-icon></div>
          </div>
          <mat-divider></mat-divider>
          <div class="document-row">
            <div  class="date-uploaded-text">Date Uploaded</div>
            <div  class="date-text">12th may 2021</div>
          </div>
        </div>
      </div>
    }
    <div class="button-container" >
      <div class="add-file-container" ><div class="margin-top-md">Add File (PDF/DOC)</div></div>
      <div class="upload-button-container" >
        <button mat-raised-button class="upload-button" type="button" (click)="fileToUpload.click()">
          Upload
        </button>
        <input
          mat-input
          #fileToUpload
          type="file"
          accept="application/pdf,.doc,.docx,application/msword"
          (change)="onFileChange(fileToUpload)"
          class="hidden-input-field"
          />
      </div>
    </div>
  </div>
</div>
